<template>
    <div  class="journal_his">
        <component :is="'VuePerfectScrollbar'" ref="historyScroll" class="scroll-area-content-h" :settings="settings" :key="$vs.rtl">
            <!-- Сообщение о пустом журнале -->
<!--            <vs-alert v-if="emptyHistory" active="true">-->
<!--                {{$t('no_data_text')}}-->
<!--            </vs-alert>-->

            <!-- Таблица -->
            <vs-table stripe :data="history_data2">
                <template slot="thead">
                    <vs-th>{{$t('date_and_time')}}</vs-th>
                    <vs-th>{{$t('name_of_student')}}</vs-th>
                    <vs-th>{{$t('act')}}</vs-th>
                    <vs-th>{{$t('full_name_user')}}</vs-th>
                    <vs-th>{{$t('old_evaluation')}}</vs-th>
                    <vs-th>{{$t('new_evaluation')}}</vs-th>
                    <vs-th>{{$t('skip')}}</vs-th>
                    <vs-th>{{$t('blocking_of_the_statement')}}</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td style="text-align: center;">
                            {{ dateReplace(data[indextr].created, true) }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].student_fio }}
                        </vs-td>
                        <vs-td style="text-align: center;">
                            <span :class="`text-${ actionReplaceColor(data[indextr].action_type) }`">
                                {{ actionReplace(data[indextr].action_type,data[indextr].comment) }}
                            </span>
                        </vs-td>
                        <vs-td>
                            <div v-if="data[indextr].action_type == 7">
                                {{ $t('text_history_vedomosti',{
                                commission:data[indextr].commission?data[indextr].commission.lastName +' '+data[indextr].commission.firstName:data[indextr].changer,
                                change:data[indextr].change.lastName +' '+data[indextr].change.firstName

                            }) }}
                            </div>
                            <div v-else-if="data[indextr].action_type == 13 || data[indextr].action_type == 14 || data[indextr].action_type == 15">
                                {{ data[indextr].change?data[indextr].change.fullname:data[indextr].changer }}
                            </div>
                            <div v-else>
                                {{ data[indextr].commission?data[indextr].commission.lastName +' '+data[indextr].commission.firstName:data[indextr].changer }}
                            </div>
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].old_estimate=="None"?'-':data[indextr].old_estimate }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].new_estimate=="None"?'-':data[indextr].new_estimate }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].pass_mark_text }}
                        </vs-td>
                        <vs-td>
                            {{ data[indextr].ej_blocking }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </component>
        <!-- Пагинация -->
<!--        <div v-if="journalHistory.count > 20" class="mt-3 important_pagination">-->
<!--            <vs-pagination :description="true" class="w-full" :total="Math.ceil(journalHistory.count / 20)" :max="6" v-model="currentPage"></vs-pagination>-->
<!--        </div>-->
    </div>
</template>

<script>
import axios from '@/configs/Axios'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from "vuex";
export default {
    params: {
        uid: {
            type: String,
            required: true
        }
    },
    components: {
        VuePerfectScrollbar
    },
    data() {
        return {
            history_data:[],
            currentPage: 1,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.50
            }
        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            GET_VEDOMOSTI_HISTORY:'vedomosti/GET_VEDOMOSTI_HISTORY'
        }),
        history_data2(){
            if (this.$route.query.uid){
                return this.history_data
            }else{
                return this.GET_VEDOMOSTI_HISTORY
            }
        }
    },
    async created() {
        await this.VedomostiHistory()
    },
    methods: {
        async VedomostiHistory(){
            try {
                this.$vs.loading();
                var route = this.$route.query
                if(route.uid){
                    await axios.get(`/schedules/vedomosti/history/`,{
                        params:{
                            vedomosti:route.uid
                        }
                    })
                        .then( (resp)=> {
                            this.history_data = resp.data
                        }).catch(function (resp) {
                            console.log(resp)
                        })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close();
            }

        },
        dateReplace(date, time = false) {
            // Переписываем дату
            return this.$moment(date).format(`DD.MM.YYYY ${ time ? 'HH:mm' : '' }`)
        },
        actionReplace(type,comment) {
            // По ид события вставляем текст события
            switch (type) {
                case 1:
                    return this.$t('Grading')
                    break;
                case 2:
                    return this.$t('rating_changed')
                    break;
                case 3:
                    return this.$t('Issuing_a_pass_with_a_reason')
                    break;
                case 4:
                    return this.$t('Changed_passes')
                    break;
                case 5:
                    return this.$t('close_vedomost')
                    break;
                case 6:
                    return this.$t('breaking_event')
                    break;
                case 7:
                    return this.$t('rating_changed')
                    break;
                case 10:
                    return this.$t('current_practice_ranking2')
                    break;
                case 11:
                    return this.$t('report_protection_rating2')
                    break;
                case 12:
                    return this.$t('anti_plagiarism_changed2')
                    break;
                case 13:
                    return this.$t('the_statement_has_been_sent_for_verification')
                    break;
                case 14:
                    return this.$t('the_statement_is_approved')
                    break;
                case 15:
                    return this.$t('notify_vedomosti_rejected_mini',{reason:comment})
                    break;
                default:
                    return '-'
            }
        },
        actionReplaceColor(type) {
            // По ид события вставляем цвет события
            switch (type) {
                case 1:
                    return 'primary'
                    break;
                case 2:
                    return 'success'
                    break;
                case 3:
                    return 'warning'
                    break;
                case 5:
                    return 'warning'
                    break;
                default:
                    return 'dark'
            }
        }
    }
}
</script>

<style lang="scss">
.journal_his{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
    .important_pagination{
        .vs-col{
            &:first-child{
                div{
                    display: none;
                }
            }
        }
    }
}
.scroll-area-content-h{
    // height: calc(var(--vh, 1vh)*100 - 33rem);
}
@media only screen and (max-width: 900px) {
    .journal_loader{
        .scroll-area-content-h{
            // height: calc(var(--vh, 1vh)*100 - 48rem);
        }
    }
}
</style>
